<div
    class="checkbox-container"
    [class.disabled]="disabled()"
    [class.flex-start]="flexStartAlignment()"
    [class.centered]="centerAlignment()"
    [class]="class()">
    <p-checkbox
        [inputId]="id() + '-checkbox'"
        [name]="id()"
        [binary]="binary()"
        [disabled]="disabled()"
        [readonly]="readonly()"
        [size]="size()"
        [(ngModel)]="value"
        (ngModelChange)="onChange.emit($event)"></p-checkbox>
    @if (label()) {
        <!-- eslint-disable-next-line @angular-eslint/template/interactive-supports-focus -->
        <label [id]="id() + '-label'" [for]="id() + '-checkbox'" [class.bold]="boldLabel()">
            {{ label() | translate }}
        </label>
        @if (required()) {
            <span class="required-mark">*</span>
        }
        @if (tooltipText()) {
            <info-tooltip [id]="id() + '-info-tooltip'" [text]="tooltipText() | translate"></info-tooltip>
        }
    }
</div>
